export default "assets/logo-baseline-73ae1ae0.svg";